import { Injectable } from '@angular/core';
//import { Http, Headers, RequestOptions } from "@angular/http";
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { server } from './constants';

@Injectable()
export class ShipmentsService {

  private httpAddress = server


    httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json'
      })
    }

  constructor(private http: HttpClient ) { }

getShipments(id):Promise<any>{
  // get the shipmentNoPod from vwShipments and return
  return this.http.get(this.httpAddress +'api/shipment/nopod/' + id)
  .toPromise()
  .then(shipmentsNoPod => shipmentsNoPod)
  .catch(err => console.log(err))
}

getShipmentsPOD(id):Promise<any>{
  // get the shipmentNoPod from vwShipments and return
  return this.http.get(this.httpAddress +'api/shipment/pod/' + id)
  .toPromise()
  .then(shipmentsPod => shipmentsPod)
  .catch(err => console.log(err))
}

getBolInvNoPod(id):Promise<any>{
  // get the shipmentNoPod from vwShipments and return
  return this.http.get(this.httpAddress +'api/shipment/invnopod/' + id)
  .toPromise()
  .then(shipmentsNoPod => shipmentsNoPod)
  .catch(err => console.log(err))
}

getBolInvPod(id):Promise<any>{
  // get the shipmentNoPod from vwShipments and return
  return this.http.get(this.httpAddress +'api/shipment/invpod/' + id)
  .toPromise()
  .then(shipmentsNoPod => shipmentsNoPod)
  .catch(err => console.log(err))
};

getVwShipments(bolqtid):Promise<any>{
  // get the shipment info from vwshipments from Bill
  return this.http.get(this.httpAddress +'api/shipment/' + bolqtid)
  .toPromise()
  .then(shipment => shipment)
  .catch(err => console.log(err))
};

onUpdateBol(post, bolqtid): Promise<any>{
  // take post data and send it to /ngagape/updatebol
  return this.http.post(this.httpAddress + 'api/shipment/updatebol/' + bolqtid, post)
  .toPromise()
  .then(response => response)
};

//use post to insert new and return the id of the new shipment req
createNewShipment(newShipment): Promise<any>{
    const body = JSON.stringify(newShipment);
    return this.http.post(this.httpAddress + "api/shipment/newbol", body, this.httpOptions)
    .toPromise()
    .then(newShipreqid => newShipreqid)
    .catch(err => console.log(err))
};

portalNewShipment(newShipment): Promise<any>{
  const body = JSON.stringify(newShipment);
  return this.http.post(this.httpAddress + "api/shipment/newportalbol", body, this.httpOptions)
  .toPromise()
  .then(newShipreqid => newShipreqid)
  .catch(err => console.log(err))
};

addShipItems(shipitem): Promise<any> {
   const body = JSON.stringify(shipitem)
   return this.http.post(this.httpAddress + "api/shipment/shipdetails", body, this.httpOptions)
    .toPromise()
    .then(shipitem => shipitem)
    .catch(err => console.log(err))
};

getShipItems(bolqtid):Promise<any>{
  // get the shipment info from vwshipments from Bill
  return this.http.get(this.httpAddress +'api/shipment/shipitems/' + bolqtid)
  .toPromise()
  .then(shipitems => shipitems)
  .catch(err => console.log(err))
};

changePuDelivId(bolqtid, id, type):Promise<any> {
  return this.http.get(this.httpAddress + 'api/shipment/addrupdate/'+ bolqtid + '/' + id + '/' + type )
  .toPromise()
  .then (response => response)
  .catch(err => console.log(err))

}

setBolStatus(bolqtid, status):Promise<any> {
  // SET ACTIVE/iNAVTIVE COLUMN in tblbolqt
  return this.http.get(this.httpAddress + 'api/shipment/bolstatus/'+ bolqtid + '/' + status )
  .toPromise()
  .then (response => response)
  .catch(err => console.log(err))

}

onUpdateShipItem(post): Promise<any>{
  // take post data and send it to /ngagape/updatebol
  return this.http.post(this.httpAddress + 'api/shipment/updateshipitem', post)
  .toPromise()
  .then(response => response)
}
updateBolqtContact(id, type, bol):Promise<any> {
  return this.http.get(this.httpAddress + `api/shipment/updatecontact/${id}/${type}/${bol}`)
  .toPromise()
  .then(result => result)
  .catch(err => console.log(err))
}

addToBoard(bolqtid, user, userid) {
  // code to send request to check board for bolqtid and/or add it if not on board
  return this.http.get(this.httpAddress + `api/board/check/${bolqtid}/${user}/${userid}`)
  .toPromise()
  .then(result => result)
  .catch(err => console.log(err))
}

updateBoard(bolqtid, user, userid) {
  // code to send request to check board for bolqtid and/or add it if not on board
  return this.http.get(this.httpAddress + `api/board/update/${bolqtid}/${user}/${userid}`)
  .toPromise()
  .then(result => result)
  .catch(err => console.log(err))
}

}



// WEBPACK FOOTER //
// ./src/app/services/shipments.service.ts